import getDomain from "utils/get_domain";
const isPreprod =
  document?.location?.host === "preprod.lexicallabs.com" ||
  document?.location?.host === "preprod-api.lexicallabs.com";
const isStaging =
  document?.location?.host === "staging.lexicallabs.com" ||
  document?.location?.host === "uat-api.lexicallabs.com";
const host = isPreprod
  ? `https://preprod-api.${getDomain()}.com`
  : isStaging
  ? `https://uat-api.${getDomain()}.com`
  : process.env.NODE_ENV === "production"
  ? `https://api.${getDomain()}.com`
  : "";
const path = `${host}/api/1.0`;

export default path;
